import { render, staticRenderFns } from "./PostsList.vue?vue&type=template&id=e5f12818&scoped=true&"
import script from "./PostsList.vue?vue&type=script&lang=ts&"
export * from "./PostsList.vue?vue&type=script&lang=ts&"
import style0 from "./PostsList.vue?vue&type=style&index=0&id=e5f12818&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f12818",
  null
  
)

export default component.exports